// vue3中创建store实例对象的方法createStore()按需引入
import { createStore } from 'vuex'
import { checkAuthStatus, setupCrossTabListener } from '../utils/auth';

const store = createStore({
  // 声明变量
  state: {
    token: '',
    userInfo: null,
    isLoggedIn: false,
    roleCodes: []
  },
  mutations: {
    // 定义mutations，用于修改状态state（因为state不能直接赋值修改，只能通过mutations进行修改）
    setRoleCodes(state,newVal){
      state.roleCodes = newVal

      console.log('---------------')
      console.log(newVal)
    },
    setAuth(state, authInfo) {
      state.token = authInfo.token;
      state.userInfo = authInfo.userInfo;
      state.isLoggedIn = true;
    },
    clearAuth(state) {
      state.token = '';
      state.userInfo = null;
      state.isLoggedIn = false;
    },
  },
  actions: {
    // 定义actions，mutations的值由actions传入
    setRoleCodes(context,newVal){
      context.commit('setRoleCodes',newVal)
    },
    initAppAuth({ commit, dispatch }) {
      // 1. 主动检查登录态
      checkAuthStatus({ commit });

      // 2. 注册跨页签监听
      setupCrossTabListener({ commit });
    },
  },
  getters: {
    // 定义一个getter
    getRoleCodes(state){
      return state.roleCodes
    }
  },
  modules: {
  }
})

export default store
